import { Goal, GoalType } from '@griply/types';

// Shared so a "goals-only" list cannot mean different things on web and mobile.
export const goalOnlyTypes: GoalType[] = [GoalType.Goal];
export const projectOnlyTypes: GoalType[] = [GoalType.Project];

// Untyped goals are regular goals — pre-converter callers can still pass a raw goal.
export const filterGoalsByType = (goals: Goal[], include: GoalType[]): Goal[] =>
  goals.filter((goal) => include.includes(goal.type ?? GoalType.Goal));
